import React from 'react';
import { ZdsFormLabel } from '@zig-design-system/ui-components-react';
import { usePowermailSettings } from '../../context/PowermailContext';
export const Text = ({ field }) => {
    const powermailSettings = usePowermailSettings();
    return (React.createElement("div", { className: `powermail_fieldwrap powermail_fieldwrap_type_content no-indentation powermail_fieldwrap_${field.marker} ${field.css} ${powermailSettings.fieldAndLabelWrappingClasses}` },
        React.createElement("div", { className: `${powermailSettings.fieldWrappingClasses} ${powermailSettings.offsetClasses}` },
            !field.hideTitle && React.createElement(ZdsFormLabel, null, field.title),
            React.createElement("p", { className: "zds-margin-top-0", style: { whiteSpace: 'pre-line' } }, field.text))));
};
